import { render } from "./page-insurance.vue?vue&type=template&id=5620b6dc"
import script from "./page-insurance.js?vue&type=script&lang=js"
export * from "./page-insurance.js?vue&type=script&lang=js"

import exportComponent from "/builds/movoto/frontend/consumer-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__